"use strict";

var diff = require('./diff');

var difference = require('./difference');

var errors = require('./errors');

var gatherValues = require('./gatherValues');

var getVersion = require('./getVersion');

var isProperFormat = require('./isProperFormat');

var mathHelpers = require('./mathHelpers');

var validateOptions = require('./validateOptions');

var getPriceTable = require('./getPriceTable');

module.exports = {
  diff: diff,
  difference: difference,
  errors: errors,
  gatherValues: gatherValues,
  getVersion: getVersion,
  isProperFormat: isProperFormat,
  mathHelpers: mathHelpers,
  validateOptions: validateOptions,
  getPriceTable: getPriceTable
};